import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Label, Form } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash-es';
import { CustomButton, CustomDashboardInput } from '../../containers';
import { useMutation } from 'react-apollo';
import { validateFormSubmission } from '../../utils/validation';
import { renderToaster, SUCCESS_TOASTER } from '../../constants/toaster';
import { handleRequestError } from '../../constants/errorCodes';
import { AdminVerifyUserMutation } from '../../operations/mutations/AdminUpdateUserMutation';
import { PartnerSelectCard } from '../PartnerSelectCard';
import { AdminSearchForHOKAccountMutation } from '../../operations/mutations/AdminSearchForHOKAccountMutation';

export const ConfirmVerificationChangeModal = ({
  isOpen,
  toggle,
  setVerified,
  verificationComment,
  setVerificationComment,
  partnerData,
  user,
}) => {
  const dispatch = useDispatch();
  const [verifyUser, { loading }] = useMutation(AdminVerifyUserMutation, {
    onError: error => handleRequestError(error, dispatch),
    onCompleted: () => {
      renderToaster(`successMessages.userVerified`, SUCCESS_TOASTER, { intlKey: true });
      setVerified(true);
      toggle();
    },
  });
  const [searchForHOKAccount, { loading: searchLoading }] = useMutation(AdminSearchForHOKAccountMutation, {
    onError: error => handleRequestError(error, dispatch),
    onCompleted: async () => {
      verifyUser({
        variables: {
          userId: `${user.id}`,
          verificationComment: verificationComment.value,
        },
      });
    },
  });

  const [selectedPartner, setSelectedPartner] = useState(user.partnerId);

  const multipleMatch = get(partnerData, 'searchForExistingHokAccount.multipleMatch', false);
  const partnersCount = get(partnerData, 'searchForExistingHokAccount.count', false);
  const partners = get(partnerData, 'searchForExistingHokAccount.partners', false);

  const changeUserVerificationStatus = async event => {
    event.preventDefault();
    let partnerId = null;
    if (partnersCount === 1 || selectedPartner) {
      partnerId = partners[0].partnerId;
    } else {
      partnerId = selectedPartner;
    }

    if (await validateFormSubmission([setVerificationComment])) {
      searchForHOKAccount({ variables: { userId: `${user.id}`, oib: user.oib, partnerId } });
    }
  };

  return (
    <Modal
      modalClassName="hok-modal dashboard-modal"
      centered
      size="sm"
      backdrop="static"
      toggle={toggle}
      isOpen={isOpen}>
      <ModalHeader className="border-0">
        <Row className="no-gutters auth-nav-links">
          <Col xs={12}>
            <h2 className="d-flex align-items-center justify-content-center">
              <FormattedMessage id="adminEditUserPage.verficationTitle" />
            </h2>
          </Col>
        </Row>
      </ModalHeader>

      <Form onSubmit={changeUserVerificationStatus}>
        <ModalBody>
          <Row className="no-gutters px-4 pt-3 font-weight-500">
            <Col xs="12">
              <Label for="verified">
                <FormattedMessage id="adminEditUserPage.areYouSureToVerifyUser" />
              </Label>
              <CustomDashboardInput
                id="verificationComment"
                fieldState={verificationComment}
                onChange={event => {
                  const value = event.target.value;
                  setVerificationComment(o => ({ ...o, invalid: false, value }));
                }}
              />
            </Col>
          </Row>
          {multipleMatch && (
            <Row className="no-gutters px-4 mt-4">
              <Col>
                {partners.map(partner => (
                  <PartnerSelectCard
                    key={partner.jmbg}
                    partner={partner}
                    selectedPartnerId={selectedPartner}
                    selectPartnerCard={setSelectedPartner}
                  />
                ))}
              </Col>
            </Row>
          )}
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <Row className="w-100">
            <Col xs={6}>
              <CustomButton type="button" className="hok-outline-btn" outline translationId="cancel" onClick={toggle} />
            </Col>
            <Col xs={6}>
              <CustomButton
                type="submit"
                className="hok-dashboard-btn"
                translationId="verify"
                loaderProp={loading || searchLoading}
              />
            </Col>
          </Row>
        </ModalFooter>
      </Form>
    </Modal>
  );
};
